import { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching/base/intent-controller';
import type { LintedMetricsEvent } from '@jet/environment/types/metrics';
import {
    type LintMetricsEventIntent,
    LintMetricsEventIntentKind,
} from './LintMetricsEventIntent';

// tslint:disable-next-line:variable-name
export const LintMetricsEventIntentController: IntentController<LintMetricsEventIntent> =
    {
        $intentKind: LintMetricsEventIntentKind.Name,
        async perform(
            intent: LintMetricsEventIntent,
            objectGraph: ObjectGraph,
        ): Promise<LintedMetricsEvent> {
            const metricsFields = intent.fields;

            return { fields: intent.fields };
        },
    };
